import { render, staticRenderFns } from "./Identifications.vue?vue&type=template&id=4ae9f0f2"
import script from "./Identifications.vue?vue&type=script&lang=js"
export * from "./Identifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports